import axios from 'axios';

export default axios.create({
    baseURL: 'https://timesheet-springboot.onrender.com',
    headers: {"ngrok-skip-browser-warning": "true"}
});